/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import { Container } from '@mantine/core'
import LeaseListCard, { LeaseListQuery } from '../lease/LeaseListCard'
import { getLeaseCreateLink } from '../../lib/links/leaseLinks'
import Page from '../../../../client/js/components/Page'
import EstateBreadcrumb from './EstateBreadcrumb'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'

function EstateLeaseListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const estateId = parseInt(params.id, 10)
  const estate = useRouteLoaderData<Estate>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: LeaseListQuery = useMemo(() => ({
    ...searchParams,
    estateId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'leases',
    defaultMessage: 'Dossiers de location'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <EstateBreadcrumb
          estate={estate}
          title={title}
        />

        <LeaseListCard
          createLink={getLeaseCreateLink({ estateId, lessorId: estate?.ownerId })}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default EstateLeaseListPage
